export default __webpack_public_path__ + "static/media/gyroZ.e766a361.svg";